import Drawing from 'dxf-writer';

const converter = (components) => {
  const d = new Drawing();
  d.setUnits('Millimeters');
  const colors = Drawing.ACI;
  const keys = Object.keys(colors);

  let counter = 0;
  components.forEach((component) => {
    const paths = component.paths;
    if (paths !== undefined) {
      paths.forEach((path) => {
        const color = colors[keys[counter % keys.length]];

        const exLayer = `cut-path-${counter}: ex_in`;
        d.addLayer(exLayer, color, `CONTINUOUS`);
        d.setActiveLayer(exLayer);

        const exPathPoints = path.ex_path.map(p => {
          return [p.x, p.y];
        });
        d.drawPolyline(exPathPoints, true);
        path.in_paths.forEach(path => {
          const inPathPoints = path.map(p => {
            return [p.x, p.y];
          });
          d.drawPolyline(inPathPoints, true);
        });

        // separate layer for pockets
        path.pocket.forEach((po, idx) => {
          const deepness = path.po_deepness[idx];

          const exPocketLayer = `#${counter}-${idx} po${deepness}mm layer`;
          d.addLayer(exPocketLayer, color, `CONTINUOUS`);
          d.setActiveLayer(exPocketLayer);

          const exPoints = po.ex_pocket.map(p => {
            return [p.x, p.y];
          });
          d.drawPolyline(exPoints, true);

          po.in_pocket.forEach((inPocket, idx2) => {
            const inPocketLayer = `#${counter}-${idx}-${idx2} po0mm layer`;
            d.addLayer(inPocketLayer, color, `CONTINUOUS`);
            d.setActiveLayer(inPocketLayer);
            const inPoints = inPocket.map(p => {
              return [p.x, p.y];
            });
            d.drawPolyline(inPoints, true);
          });
        });

        if (path.single_paths) {
          path.single_paths.forEach((sPath, idx) => {
            const deepness = path.single_deepness[idx];
            const singlePathLayer = `#${counter}-${idx} single_path${deepness}mm layer`;
            d.addLayer(singlePathLayer, color, `CONTINUOUS`);
            d.setActiveLayer(singlePathLayer);
  
            const singlePathPoints = sPath.map(p => {
              return [p.x, p.y];
            });
            d.drawPolyline(singlePathPoints, true);
          });
        }

        counter++;
      });
    }
  });

  return d.toDxfString();
};

export { converter };



// WEBPACK FOOTER //
// ./src/assets/javascripts/dxf/DxfConverter.js